<template>
  <img :class="$style.ouluport_background" alt="" src="@/assets/ouluport_background.png" />
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'OuluportBackground'
})
</script>
<style module>
.ouluport_background {
  width: 100%;
  position: absolute;
  margin: 0 !important;
  /* top: 0px; */
  left: 0px;
  height: 1024px;
  object-fit: cover;
}
</style>
